export default "__VITE_ASSET__UCWOLkDq__"